module.exports = "//static.hsappstatic.net/crm-object-board-card/static-1.10610/images/Illustration.png"